import { AxiosInstance } from 'axios'
import type {
  CompareStatusResponse,
  CreateComparisonParams,
} from '@dc-shared-web/hooks/api/comparison/types'

export const createComparison = async (
  apiClient: AxiosInstance,
  params: CreateComparisonParams
): Promise<CompareStatusResponse> => {
  const response = await apiClient.post('/v1/comparison/compare', params)
  return response.data
}
